/**
 * 用户行为分析模块
 * 转换为Vue 3风格的ES模块
 */

// 导入需要的依赖
import constGlobal from '@/assets/js/ConstGlobal'; // 根据实际路径调整导入

/**
 * Analytics类 - 用于用户行为数据收集和上报
 */
export default class Analytics {
  constructor(param = {}) {
    // 初始化用户行为数据对象
    this.userActionDataJson = {
      domain: '', // 域名
      language: '', // 客户端语言
      resolution: '', // 分辨率
      browser: '',  // 访问的浏览器
      clientType: '', // 访问的客户端类型
      deviceId: '', // 设备uuid
      model: '', // 设备机型
      deviceVersion: '', // 系统版本号
      manufacturer: '', // 制造商
      serial: '', // 硬件序列号
      devicePlatform: '', // 设备操作系统
      longitude: '', // 经度
      latitude: '', // 纬度
      appVersion: ''
    };
    
    // 应用ID
    this.agentId = param.agentId || '';
    
    // 事件数据对象
    this.event = {
      eventCode: '',
      eventAttr: {}
    };
    
    // 其他数据
    this.otherData = {
      enterTime: ''
    };
    
    // 获取userAgent
    this.userAgent = window.navigator.userAgent.toLowerCase();
    
    // 初始化数据
    this.initData();
  }
  
  /**
   * 检查userAgent是否包含指定字符串
   * @param {string} needle - 要查找的字符串
   * @returns {boolean} 是否包含
   */
  find(needle) {
    return this.userAgent.indexOf(needle) !== -1;
  }
  
  /**
   * 初始化基础信息
   */
  initBaseInfo() {
    // 设置域名
    // this.userActionDataJson.domain = document ? document.domain : '';
    this.userActionDataJson.domain = typeof window !== 'undefined' && window.location ? window.location.hostname : '';
    
    // 设置客户端语言
    this.userActionDataJson.language = navigator.language || navigator.systemLanguage || 
                                       navigator.userLanguage || 'Other';
    
    // 设置分辨率
    this.userActionDataJson.resolution = (window.screen.width || 0) + 'x' + 
                                         (window.screen.height || 0);
   
    // 检测浏览器类型
    this._detectBrowser();
    
    // 检测客户端类型
    this._detectClientType();
    
    
    // 尝试获取已存储的位置信息
    // console.log('开始检查存储的位置信息');
    // const locationInfo = sessionStorage.getItem('deviceLocationInfo');
    // // console.log('从sessionStorage获取的位置信息:', locationInfo);
    
    // if (locationInfo) {
    //   // console.log('检测到存储的位置信息，开始解析');
    //   try {
    //     const position = JSON.parse(locationInfo);
    //     // console.log('成功解析位置信息:', position);
        
    //     // 检查解析后的数据是否有效
    //     if (position && (position.latitude || position.longitude)) {
    //       this.userActionDataJson.latitude = position.latitude || '';
    //       this.userActionDataJson.longitude = position.longitude || '';
    //       // console.log('位置信息已更新到userActionDataJson:', {
    //       //   latitude: this.userActionDataJson.latitude,
    //       //   longitude: this.userActionDataJson.longitude
    //       // });
    //     } else {
    //       console.warn('解析的位置信息无效或不完整');
    //     }
    //   } catch (error) {
    //     console.error('解析位置信息失败:', error);
    //     // 失败后尝试获取当前位置作为备选
    //     this._tryGetCurrentLocation();
    //   }
    // } else {
    //   console.log('未检测到存储的位置信息，尝试获取当前位置');
    //   // 如果没有存储的位置信息，尝试获取当前位置
    //   this._tryGetCurrentLocation();
    // }
  }
  
  /**
   * 检测浏览器类型
   * 基于User-Agent字符串识别各种浏览器，并返回人类可读的浏览器名称
   * @private
   * @returns {string} 浏览器名称
   */
  _detectBrowser() {
    // 确保window.navigator存在，防止在非浏览器环境中报错
    if (!window || !window.navigator) {
      this.userActionDataJson.browser = '非浏览器环境';
      return;
    }
    const agent = window.navigator.userAgent.toLowerCase();
    let browser = '';
    
    // IE 11 的特殊处理，需要放在最前面避免被其他判断捕获
    if (Object.hasOwnProperty.call(window, 'ActiveXObject') && !window.ActiveXObject) {
      browser = 'IE 11';
    } 
    // 老版本IE
    else if (/msie ([\d.]+)/.test(agent)) {
      const s = agent.match(/msie ([\d.]+)/);
      browser = 'IE ' + (s && s[1] ? s[1] : '未知版本');
    }
    // Edge浏览器 (基于Chromium的新版)
    else if (/edg\//.test(agent)) {
      browser = 'Edge';
    }
    // Firefox
    else if (/firefox\/([\d.]+)/.test(agent)) {
      browser = 'Firefox';
    }
    // 基于Chromium的浏览器系列
    else if (/chrome\/([\d.]+)/.test(agent)) {
      // 360安全浏览器
      if (/360se/.test(agent)) {
        browser = '360安全浏览器';
      }
      // 360极速浏览器
      else if (/360chrome/.test(agent)) {
        browser = '360极速浏览器';
      }
      // QQ浏览器
      else if (/qqbrowser\/([\d.]+)/.test(agent)) {
        browser = 'QQ浏览器';
      }
      // 搜狗浏览器
      else if (/metasr/.test(agent)) {
        browser = '搜狗浏览器';
      }
      // 猎豹浏览器
      else if (/lbbrowser/.test(agent)) {
        browser = '猎豹浏览器';
      }
      // 遨游浏览器
      else if (/maxthon\/([\d.]+)/.test(agent)) {
        browser = '遨游浏览器';
      }
      // 新版Edge (包含Edge/版本号)
      else if (/edg\//.test(agent)) {
        browser = 'Edge';
      }
      // 微信浏览器
      else if (/micromessenger/.test(agent)) {
        browser = '微信浏览器';
      }
      // 钉钉内置浏览器
      else if (/dingtalk/.test(agent)) {
        browser = '钉钉浏览器';
      }
      // 百度浏览器
      else if (/bidubrowser/.test(agent)) {
        browser = '百度浏览器';
      }
      // UC浏览器
      else if (/ucbrowser/.test(agent)) {
        browser = 'UC浏览器';
      }
      // 最后才判断为Chrome
      else {
        browser = 'Chrome';
      }
    }
    // Opera
    else if (/opera.([\d.]+)/.test(agent)) {
      browser = 'Opera';
    }
    // Safari (需要放在Chrome判断之后，因为Safari的UA也包含Chrome的特征)
    else if (/version\/([\d.]+).*safari/.test(agent)) {
      browser = 'Safari';
    }
    // 微信小程序
    else if (agent.indexOf('miniprogram') !== -1) {
      browser = '微信小程序';
    }
    // 添加移动浏览器的检测
    else if (/mobile/.test(agent)) {
      if (/iphone|ipad|ipod/.test(agent)) {
        browser = 'iOS设备浏览器';
      } else if (/android/.test(agent)) {
        browser = 'Android设备浏览器';
      } else {
        browser = '移动设备浏览器';
      }
    }
    // 默认情况
    else {
      browser = '未知浏览器';
    }
    
    // 将检测结果保存到数据对象中
    this.userActionDataJson.browser = browser;
  }
  
  /**
   * 检测客户端类型
   * 基于User-Agent字符串识别客户端类型，包括微信、Android、iOS等平台
   * @private
   */
  _detectClientType() {
    let clientType = '';
    
    // 优先检测微信环境
    if (this.find('micromessenger')) {
      // 检测是否为微信小程序
      if (this.find('miniprogram')) {
        clientType = 'WECHAT_MINI_PROGRAM';
      } else {
        clientType = 'WECHAT';
      }
    }
    // 检测Android设备 (排除Windows设备上的Android模拟器)
    else if (!this.find('windows') && this.find('android')) {
      // 判断是否为平板设备
      if (this.find('tablet') || window.innerWidth >= 768 && /mobile/.test(this.userAgent)) {
        clientType = 'ANDROID_TABLET';
      } else {
        clientType = 'ANDROID';
      }
    }
    // 检测iOS设备
    else if (!this.find('windows') && 
             (this.find('iphone') || this.find('ipod') || this.find('ipad'))) {
      // 区分iPhone/iPod和iPad
      if (this.find('ipad')) {
        clientType = 'IOS_IPAD';
      } else {
        clientType = 'IOS';
      }
    }
    // 检测桌面浏览器
    else if (this.find('windows') || this.find('macintosh') || this.find('linux')) {
      clientType = 'DESKTOP';
    }
    // 检测其他移动设备
    else if (/mobile|phone|webos/.test(this.userAgent)) {
      clientType = 'MOBILE_OTHER';
    }
    // 默认类型
    else {
      clientType = 'UNKNOWN';
    }
    
    // 存储客户端类型
    this.userActionDataJson.clientType = clientType;
    
    // 仅在移动原生应用环境中添加deviceready事件监听
    // 确保document对象存在，避免在非浏览器环境中报错
    if (typeof document !== 'undefined' && 
        (clientType === 'ANDROID' || clientType === 'IOS' || 
         clientType === 'ANDROID_TABLET' || clientType === 'IOS_IPAD')) {
      // 检查是否已经准备好，如果已准备好则立即调用
      if (window.cordova && window.cordova.platformId) {
        this.onDeviceReady();
      } else {
        document.addEventListener('deviceready', this.onDeviceReady.bind(this), false);
      }
    }
  }
  
  /**
   * 获取位置信息成功回调
   * @param {Object} position - 位置信息对象
   */
  getLocationOnSuccess(position) {
    this.userActionDataJson.latitude = position.coords.latitude;
    this.userActionDataJson.longitude = position.coords.longitude;
  }
  
  /**
   * 获取位置信息失败回调
   * @param {Error} error - 错误信息
   */
  getLocationOnError(error) {
    console.log('获取位置信息失败:', error);
  }
  
  /**
   * 设置事件数据并发送日志信息
   * @param {Object} param - 事件参数
   */
  setEventStr(param) {
    
    this.event.eventAttr = {};
    
    if (param.eventCode) {
      this.event.eventCode = param.eventCode;
    }
    
    if (param.eventAttr) {
      Object.keys(param.eventAttr).forEach(key => {
        this.event.eventAttr[key] = param.eventAttr[key];
      });
    }
    
    if (this.agentId) {
      this.event.eventAttr.agentId = this.agentId;
    } else if (param.eventAttr?.agentId) {
      this.event.eventAttr.agentId = param.eventAttr.agentId;
    }
    this.sendInfomation();
  }
  
  /**
   * 发送信息到服务器
   */
  sendInfomation() {
    this.initBaseInfo();
    
    // 使用更现代的方式构建URL参数
    let params = Object.entries(this.userActionDataJson)
      .filter(([_, value]) => value !== null && value !== undefined && value !== '') // 过滤空值
      .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
      .join('&');
      
    // 添加参数前缀
    if (params) {
      params = `&${params}`;
    }
    
    // 安全地构建事件数据字符串
    // let eventStr = '';
    // try {
    //   eventStr = encodeURIComponent(JSON.stringify(this.event));
    // } catch (e) {
    //   console.error('构建事件数据失败:', e);
    //   eventStr = encodeURIComponent(JSON.stringify({}));
    // }
    
    // // 安全地获取基础URL
    // const baseUrl = constGlobal?.MainHost || '';
    
    // // 构建完整请求URL
    // let url = '';
    // if (baseUrl) {
    //   url = `${baseUrl}/log/userBehavior/log.gif?event=${eventStr}${params}`;
      
    //   // 检查URL长度，防止请求失败
    //   if (url.length > 2000) {
    //     console.warn('分析数据URL过长，可能导致请求失败');
    //     // 可以在这里添加URL截断或精简逻辑
    //   }
    // }
    
    // // 仅在开发环境或调试模式下打印日志
    // if (process.env.NODE_ENV === 'development') {
    //   console.log('准备发送分析数据到:', baseUrl);
    // }
    
    // // 安全地发送请求
    // if (url) {
    //   try {
    //     // 使用图片像素方式发送请求，避免跨域问题
    //     const img = new Image(1, 1);
        
    //     // 添加错误处理
    //     img.onerror = () => {
    //       if (process.env.NODE_ENV === 'development') {
    //         console.warn('分析数据发送失败，但不影响功能');
    //       }
    //     };
        
    //     // 添加加载完成处理（可选）
    //     img.onload = () => {
    //       if (process.env.NODE_ENV === 'development') {
    //         console.log('分析数据发送成功');
    //       }
    //     };
        
    //     img.src = url;
    //   } catch (e) {
    //     // 捕获所有可能的异常，确保不影响主应用
    //     if (process.env.NODE_ENV === 'development') {
    //       console.error('发送分析数据时出错:', e);
    //     }
    //   }
    // } else {
    //   if (process.env.NODE_ENV === 'development') {
    //     console.warn('无法构建分析数据请求URL');
    //   }
    // }
  }
  
  /**
   * 初始化事件
   */
  initEvent() {
    // 进入页面事件
    const date = new Date();
    this.otherData.enterTime = date.getTime();
    this.enterPage();
  }
  
  /**
   * 进入页面事件
   */
  enterPage() {
    const date = new Date();
    this.setEventStr({
      eventCode: 'enterPage',
      eventType: 'sys',
      eventAttr: {
        enterTime: date.getTime(),
        stopTime: this.otherData.enterTime ? 
                  (date.getTime() - this.otherData.enterTime) : '',
        url: window.location.href,
        title: document.title,
        referrer: document.referrer
      }
    });
  }
  
  /**
   * 退出页面事件
   */
  leavePage() {
    const date = new Date();
    this.setEventStr({
      eventCode: 'enterPage',
      eventType: 'sys',
      eventAttr: {
        leaveTime: date.getTime(),
        stopTime: this.otherData.enterTime ? 
                  (date.getTime() - this.otherData.enterTime) : '',
        url: window.location.href,
        title: document.title,
        referrer: document.referrer
      }
    });
  }
  
  /**
   * 下载应用事件
   * @param {string} agentId - 应用ID
   */
  loadAgent(agentId) {
    const date = new Date();
    this.setEventStr({
      eventCode: 'loadAgent',
      eventType: 'sys',
      eventAttr: {
        agentId: agentId,
        loadTime: date.getTime()
      }
    });
  }
  
  /**
   * 删除应用事件
   * @param {string} agentId - 应用ID
   */
  delAgent(agentId) {
    const date = new Date();
    this.setEventStr({
      eventCode: 'delAgent',
      eventType: 'sys',
      eventAttr: {
        delAgentId: agentId,
        delAgentTime: date.getTime()
      }
    });
  }
  
  /**
   * 登录事件
   */
  login() {
    const date = new Date();
    this.setEventStr({
      eventCode: 'login',
      eventType: 'sys',
      eventAttr: {
        loginTime: date.getTime()
      }
    });
  }
  
  /**
   * 登出事件
   */
  loginOut() {
    const date = new Date();
    this.setEventStr({
      eventCode: 'loginOut',
      eventType: 'sys',
      eventAttr: {
        loginOutTime: date.getTime()
      }
    });
  }
  
  /**
   * 进入应用事件
   * @param {string} agentId - 应用ID
   */
  enterAgent(agentId) {
    const date = new Date();
    this.setEventStr({
      eventCode: 'enterAgent',
      eventType: 'sys',
      eventAttr: {
        agentId: agentId,
        leaveTime: date.getTime(),
        stopTime: this.otherData.enterTime ? 
                  (date.getTime() - this.otherData.enterTime) : '',
        url: window.location.href,
        title: document.title,
        referrer: document.referrer
      }
    });
  }
  
  /**
   * 出错记录
   * @param {string} errorMsg - 错误信息
   * @param {string} errorMethod - 错误方法
   */
  errorRecord(errorMsg, errorMethod) {
    const date = new Date();
    this.setEventStr({
      eventCode: 'errorRecord',
      eventType: 'sys',
      eventAttr: {
        errorTime: date,
        errorMsg: errorMsg,
        errorMethod: errorMethod
      }
    });
  }
  
  /**
   * 自定义事件
   * @param {string} type - 事件类型
   * @param {string} action - 事件动作
   * @param {Object} params - 事件参数
   */
  customEvent(type = '', action = 'default', params = { type: 1 }) {
    this.setEventStr({
      eventType: type,
      eventCode: action,
      eventAttr: params
    });
  }
  
  /**
   * 设备就绪回调
   * @private
   */
  onDeviceReady() {
    // 设备就绪时的处理逻辑
    // 可以在这里添加Cordova相关的初始化代码
  }
  
  /**
   * 尝试获取当前位置信息
   * @private
   */
  _tryGetCurrentLocation() {
    // console.log('尝试获取当前位置信息');
    
    // 检查浏览器是否支持Geolocation API
    if (typeof navigator !== 'undefined' && navigator.geolocation) {
      try {
        // console.log('浏览器支持Geolocation API，开始获取位置');
        
        // 尝试获取位置信息
        navigator.geolocation.getCurrentPosition(
          // 成功回调
          (position) => {
            if (position && position.coords) {
              const locationData = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
              };
              
              // 保存到sessionStorage
              try {
                sessionStorage.setItem('deviceLocationInfo', JSON.stringify(locationData));
                console.log('位置信息已保存到sessionStorage:', locationData);
              } catch (storageError) {
                console.error('保存位置信息到sessionStorage失败:', storageError);
              }
              
              // 更新到用户数据对象
              this.userActionDataJson.latitude = position.coords.latitude;
              this.userActionDataJson.longitude = position.coords.longitude;
              // console.log('成功获取位置信息并更新:', locationData);
            }
          },
          // 错误回调
          (error) => {
            // console.warn('获取位置信息失败:', error.message);
            // 根据错误类型提供更具体的提示
            switch(error.code) {
              case error.PERMISSION_DENIED:
                console.warn('用户拒绝了位置共享请求');
                break;
              case error.POSITION_UNAVAILABLE:
                console.warn('位置信息不可用');
                break;
              case error.TIMEOUT:
                console.warn('获取位置信息超时');
                break;
            }
          },
          // 配置选项
          {
            enableHighAccuracy: false, // 不需要高精度定位
            timeout: 10000,            // 10秒超时
            maximumAge: 300000         // 5分钟内可重用缓存位置
          }
        );
      } catch (geoError) {
        console.error('调用geolocation API时出错:', geoError);
      }
    } else {
      console.warn('浏览器不支持Geolocation API');
    }
  }

  /**
   * 初始化项目
   */
  initData() {
    this.initBaseInfo();
    this.initEvent();
  }
}